import { Trial_Status } from '@generated/graphql';
import { generateOptions } from '@myhrbox/myhrbox-frontend-core';
import { LocaleKey } from 'types/i18n';

export const ASSESSMENT_STATUS_TITLE: Record<Trial_Status, LocaleKey> = {
  [Trial_Status.Created]: 'assessmentStatus.created',
  [Trial_Status.Received]: 'assessmentStatus.received',
  [Trial_Status.Started]: 'assessmentStatus.started',
  [Trial_Status.Completed]: 'assessmentStatus.completed',
  [Trial_Status.Canceled]: 'assessmentStatus.canceled',
  [Trial_Status.Suspended]: 'assessmentStatus.suspended',
};

export const ASSESSMENT_STATUS_OPTIONS: Array<{ id: Trial_Status; displayName: string }> =
  generateOptions(ASSESSMENT_STATUS_TITLE);

export const TRIAL_IS_NOT_AVAILABLE_ERROR_MESSAGE = 'Error: Trial not available';
export const EXAMINATION_IS_NOT_AVAILABLE_ERROR_MESSAGE = 'Error: Examination is not available';
